// extracted by mini-css-extract-plugin
export default {"sections-list":"HistoryForm_sections-list__8p57l","sections-divider":"HistoryForm_sections-divider__WovE3"};